import appConstants from "../../../../../../appConstants";
const DRIVER_INFO_GRID_FILTERS = {
  ALL: {
    label: "All",
    value: null,
  },
  COMPLETED: {
    label: "Completed",
    value: true,
  },
  PENDING: {
    label: "Pending",
    value: false,
  },
};

const DRIVER_INFO_GRID_FILTER_OPTIONS = [
  DRIVER_INFO_GRID_FILTERS.ALL,
  DRIVER_INFO_GRID_FILTERS.COMPLETED,
  DRIVER_INFO_GRID_FILTERS.PENDING,
];


const gridShortHeaderNamesConfig = {
  state: {
    headerName: "ST",
    minWidth: appConstants.columnWidth.W_70,
  },
  weight: {
    headerName: "Wgt",
    minWidth: appConstants.columnWidth.W_85,
  },
};

export {
  DRIVER_INFO_GRID_FILTER_OPTIONS,
  DRIVER_INFO_GRID_FILTERS,
  gridShortHeaderNamesConfig,
};
